import Heading from '@atlaskit/heading';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  displayName: string;
}

const ContinueAsHeader = ({ displayName }: Props) => {
  return (
    <React.Fragment>
      {displayName ? (
        <Heading as="h1" size="small">
          <FormattedMessage id="continue.as.title.as" defaultMessage="Continue as" />
        </Heading>
      ) : (
        <FormattedMessage
          id="continue.as.title.as.application"
          tagName="div"
          defaultMessage="Continue to the application"
        />
      )}
    </React.Fragment>
  );
};

export default ContinueAsHeader;
